module.exports = __webpack_public_path__ + "img/eg4.4ec73e1f.png";